import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth';

export const permissionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const requiredPermission = route.data?.['permission'];

  const userPermissions =
    authService.currentUser()?.admin?.permissions_with_role?.permissions ?? [];

  if (!requiredPermission || userPermissions.includes(requiredPermission)) {
    return true;
  }

  // Redirect to first allowed route
  const firstAllowedRoute = getFirstAllowedRoute(userPermissions);

  return router.createUrlTree([firstAllowedRoute]);
};

export function getFirstAllowedRoute(permissions: string[]): string {
  const permissionRoutes: Record<string, string> = {
    home: '/dashboard',
    admins: '/dashboard/admins',
    validations: '/dashboard/validations',
    users: '/dashboard/users',
    platform_content: '/dashboard/platform-content',
    pending_approvals: '/dashboard/pending-approvals',
    content_moderation: '/dashboard/content-moderation',
    reports: '/dashboard/reports',
  };

  for (const permission of permissions) {
    if (permissionRoutes[permission]) {
      return permissionRoutes[permission];
    }
  }

  return '/login';
}
